// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"751":"07195760","769":"fad06a3b"}[chunkId] + ".chunk.css";
};